import { AddImage } from "./AddImageModal";

export default [
    {name: 'AddImage', title:"Add Image", component: AddImage}
];